import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const CostCodeIndicatorStyled = styled(Box)`
  ${({ theme }) => css`
    width: ${theme.spacings[300]};
    background-color: ${theme.colors.grey[500]};
  `};
`;
